import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Box, Grid, Popover, Typography } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import { getLogs } from '../../state/order/actions';
import { grey } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  skeleton: {
    backgroundColor: '#ccc',
  },
  listContent: {
    borderBottom: `1px solid ${grey[200]}`,
    borderTop: `1px solid ${grey[200]}`,
    maxHeight: '50vh',
    minWidth: 380,
    minHeight: 130,
  },
  action: {
    padding: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  table: {
    minWidth: 1000,
  },
}));

export default function AssociadosModal(props) {
  const { logs, loaded } = useSelector(state => state.orders.logs);
  const { open, handleClose, codigoExterno, origem, loja } = props;
  const [pop, setPop] = React.useState({ open: false, anch: null, txt: null });

  const classes = useStyles();
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (codigoExterno && origem)
    dispatch(getLogs(codigoExterno, origem));
  }, [dispatch, codigoExterno, origem]);

  const handlePopClick = (event, txt) => {
    setPop({ open: true, anch: event.currentTarget, txt });
  };

  const handlePopClose = () => {
    setPop({ open: false, anch: null, txt: null });
  };

  const renderLog = ({ response, responseTime, ...log }) => (
    <TableRow key={log._id}>
      <TableCell component="th" scope="row">
        {log.action}
      </TableCell>
      <TableCell align="left">{new Date(log.dateTime).toLocaleString()}</TableCell>
      <TableCell align="right">{responseTime || 0} ms</TableCell>
      <TableCell align="left">{log.usuario}</TableCell>
      <TableCell align="left">{log.url}</TableCell>
      <TableCell align="left">
        <Grid container direction="row">
          <Grid item xs={6}>
            <Button size="small" color="primary" onClick={(e) => handlePopClick(e, log)}>
              Req
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button size="small" onClick={(e) => handlePopClick(e, response)}>
              Res
            </Button>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>
  );

  const renderSkeleton = (i) => (
    <TableRow key={i}>
      <TableCell component="th" scope="row">
        <Skeleton variant="text" animation="wave" className={classes.skeleton} />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" animation="wave" className={classes.skeleton} />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" animation="wave" className={classes.skeleton} />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" animation="wave" className={classes.skeleton} />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" animation="wave" className={classes.skeleton} />
      </TableCell>
      <TableCell>
        <Skeleton variant="text" animation="wave" className={classes.skeleton} />
      </TableCell>
    </TableRow>
  );

  const renderTable = () => (
    <TableContainer component={Paper}>
      <Popover
        open={pop.open}
        anchorEl={pop.anch}
        onClose={handlePopClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Typography>
          <pre>{JSON.stringify(pop.txt || {}, null, 2)}</pre>
        </Typography>
      </Popover>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Ação</TableCell>
            <TableCell>Data/Hora</TableCell>
            <TableCell>Duração</TableCell>
            <TableCell>Usuário</TableCell>
            <TableCell>URL</TableCell>
            <TableCell> </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loaded
            ? logs.map(renderLog)
            : [1, 2, 3, 4, 5].map(renderSkeleton)
          }
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle>Loja: {loja} Pedido: {codigoExterno}</DialogTitle>

        <DialogContent className={classes.listContent}>
          {renderTable()}
        </DialogContent>
        <DialogActions className={classes.action}>
          <Box flexGrow={1} display="flex" p={0}>
            <Box flexGrow={1} >
              <Button onClick={handleClose} color="inherit">Fechar</Button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  )
}
